var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBadgeHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M12.667 14.5C13.12 11.715 16 12.253 16 9.737 16 8.076 14.463 7 12.35 7 9.711 7 8.174 8.598 8 10.766h1.59c.157-1.567 1.082-2.563 2.585-2.563 1.31 0 2.06.632 2.06 1.66 0 1.931-2.756 1.41-2.983 4.637h1.415zm-1.75 2.5h1.834v-1.646h-1.834V17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M12.751 17h-1.834v-1.646h1.834V17z"
  }));
}
export default SvgIconBadgeHelp;